import classNames from 'classnames';
import * as _ from 'lodash';
import { useEffect, useState } from 'react';

import { MarkdownText } from '@basic';
import { setupForDark } from '@theme';

function TextInputReadonly({
  value,
  withMarkdown,
  className = ''
}: {
  value: string;
  withMarkdown?: boolean;
  className?: string;
}) {
  const [inputValue, setInputValue] = useState(null);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  if (_.isNil(inputValue) || !inputValue) {
    return (
      <div
        className={classNames(
          setupForDark('text-tertiary'),
          'my-sm P2R line-clamp-4 break-words',
          className
        )}
      >
        <div>...</div>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        setupForDark('text-tertiary'),
        'my-sm P2R line-clamp-4 break-words',
        className
      )}
    >
      {withMarkdown && <MarkdownText text={inputValue} />}
      {!withMarkdown && inputValue}
    </div>
  );
}

export default TextInputReadonly;
